import React from "react";
import MyAppBar from "../component/appBarcomponent/MyAppbar";
//import NavBar from '../component/appBarcomponent/Navbar';
import Body from "./HomeBody";
import useWindowSize from "../util/useWindowSize";
import "../css/Morquee.css";
import {
  CssBaseline,
  Stack,
} from "@mui/material";

import CreateEventSection from "./CreateEventSection/CreateEventSection";
import Howdoeswork from "./howdoeswork/Howdoeswork";
import Howdoesitwork from "./howdoesitwork/Howdoesitwork";
import MiddleContent from "./MiddleContent";
import ProviderServices from "./ProviderServices";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";

const HomePage = () => {
  const width = useWindowSize();

  return (
    <div>
      <CssBaseline />
      <Navbar/>
      <CreateEventSection />
      <ProviderServices />
      <Howdoesitwork />
      <MiddleContent />
      <Footer />
    </div>
  );
};

export default HomePage;
